import React, { useCallback, useEffect, useRef, useState } from "react";
import {
  benamingKlachten,
  radiobutton1,
  KlachtenTitel,
} from "../../klantenregister";
import RPRadioButtonSmall from "../../Componenten/Radiogroup/RadioButtonSmall";
import Swal from "sweetalert2";
import {
  ArrowDownIcon,
  ArrowLeftCircleIcon,
  ArrowRightCircleIcon,
} from "@heroicons/react/20/solid";
import Slider from "react-slick/lib/slider";
import {
  getKlacht,
  getUserdetails,
  setStates,
} from "../../Localstorage/localstorage";
import {
  opslaanKlachten,
  opslaanOpmerkingKlachten,
  versturenKlachten,
} from "../../apiCalls/klachtenformulierApi";
import { emailKlachtenBevestigingHTML } from "../../EmailTemplates";
import { sendEmail } from "../../function";

function classNames(...classes) {
  return classes.filter(Boolean).join(" ");
}

const Bedankt = ({ handleClose, versturen }) => (
  <div className="flex min-h-[min(100dvh,36rem)] items-center justify-center bg-wa-app px-4 py-10">
    <div className="w-full max-w-lg rounded-2xl border border-wa-border bg-wa-panel2/50 p-8 shadow-[0_22px_55px_-36px_rgba(0,0,0,0.5)] ring-1 ring-black/[0.04] dark:ring-white/[0.06]">
      <h1 className="mb-4 text-center text-2xl font-bold tracking-tight text-wa-accent sm:text-3xl">
        Bedankt voor het invullen!
      </h1>
      <p className="mb-4 text-center text-sm leading-relaxed text-wa-muted">
        We waarderen uw tijd en zorgvuldigheid bij het invullen van het formulier.
      </p>
      <p className="mb-4 text-center text-sm leading-relaxed text-wa-muted">
        Uw gegevens zijn veilig ontvangen en worden zorgvuldig door ons team beoordeeld.
      </p>
      <p className="mb-4 text-center text-sm leading-relaxed text-wa-muted">
        Binnenkort nemen wij contact met u op om een intakegesprek te plannen.
      </p>
      <p className="mb-6 text-center text-sm leading-relaxed text-wa-muted">
        Hartelijk dank voor uw vertrouwen in onze zorg.
      </p>
      <button
        type="button"
        onClick={handleClose}
        className="w-full rounded-xl bg-wa-panel py-3 text-sm font-semibold text-wa-text ring-1 ring-wa-border transition hover:bg-wa-hover"
      >
        Sluiten
      </button>
      <button
        type="button"
        onClick={versturen}
        className="mt-3 w-full rounded-xl bg-wa-accent py-3 text-sm font-semibold text-wa-onaccent shadow-md transition hover:bg-wa-accentdeep"
      >
        Verzenden
      </button>
    </div>
  </div>
);

const RpKlachtenRegisterForm = ({
  klachten,
  setKlachten,
  klacht,
  status,
  setOpen,
  admin = null,
  onProgressUpdate,
}) => {
  const topRef = useRef(null);
  const [slideIndex, setSlideIndex] = useState(0);
  const [extra, setExtra] = useState(0);
  const [isSaving, setIsSaving] = useState(false);
  const userdetails = getUserdetails();

  const sliderRef = useRef(null);

  const settings = {
    dots: false,
    infinite: false,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    swipe: true,
    beforeChange: (_current, next) => setSlideIndex(next),
  };

  const [opAdminOpmerking, setopAdminOpmerking] = useState(null);
  const [Opmerking, setOpmerking] = useState(null);
  const [categorie, setCategorie] = useState(klachten);
  const startAdmin = admin ? 0 : status?.id;
  const [selectKlacht, setSelectKlacht] = useState(startAdmin);
  const vragenlijst = getKlacht();

  const handleChange = useCallback((e) => {
    const { name, value } = e.target;

    if (admin && name === 'opm_admin') {
      setopAdminOpmerking(value);
    }

    setKlachten((prevState) => ({
      ...prevState,
      [benamingKlachten[selectKlacht]?.key]: {
        ...prevState[benamingKlachten[selectKlacht]?.key],
        [name]: value,
      },
    }));
  }, [admin, selectKlacht, benamingKlachten]);

  useEffect(() => {
    if (admin || vragenlijst?.versturen == 1) {
      setSelectKlacht(0);
      return;
    }
    if (status?.id != null && !Number.isNaN(Number(status.id))) {
      setSelectKlacht(Number(status.id));
    }
  }, [status?.id, admin, vragenlijst?.versturen]);

  useEffect(() => {
    topRef.current?.scrollIntoView({ behavior: "smooth", block: "start" });
  }, [selectKlacht]);

  useEffect(() => {
    if (benamingKlachten[selectKlacht]) {
      setopAdminOpmerking(
        klachten[benamingKlachten[selectKlacht]?.key]?.opm_admin
      );
      if(admin){
        setOpmerking(klachten[benamingKlachten[selectKlacht]?.key]?.opm_admin);
      }
    }
    let categorie = klachten[benamingKlachten[selectKlacht]?.key];
    //console.log("categorie ==> ",categorie);
    //console.log("selectKlacht ==> ",selectKlacht);

  }, [selectKlacht]);

  const verSturen = async () => {
    if (typeof onProgressUpdate === "function") {
      await onProgressUpdate({ optimisticName: "voeding", revalidate: false });
    }

    const ok = await versturenKlachten(klacht, setOpen);
    if (!ok) {
      if (typeof onProgressUpdate === "function") {
        await onProgressUpdate({ revalidate: true });
      }
      return;
    }

    const emailData = {
      from_name: "RepeatConnect Klachtenregister formulier Verzonden",
      sender_email: "info@repeathealth.com", // Replace with dynamic sender email
      title: `Hallo ${userdetails?.first_name}, Uw ingevulde klachtenregisterformulier is succesvol verzonden.`,
      receiver_email: userdetails?.email, // Replace with dynamic receiver email
      gebruikersnaam: userdetails?.email, // Replace with dynamic userdetailsname
      name: userdetails?.full_name,
      inloglink: "https://repeatconnect.com", // Replace with the login URL
    };

    const emailHtml = emailKlachtenBevestigingHTML(emailData);
    sendEmail("template_qdoh9mv", {
      message_html: emailHtml,
      title: emailData?.title,
      receiver_email: emailData?.receiver_email,
    });
    if (typeof onProgressUpdate === "function") {
      await onProgressUpdate();
    }
  };

  const Opslaan = async () => {
    const categorie = klachten[benamingKlachten[selectKlacht]?.key];
    const meta = benamingKlachten[selectKlacht];
    if (!categorie || !meta) {
      return false;
    }

    let ok = false;
    if (admin == null) {
      ok = await opslaanKlachten(
        klacht,
        selectKlacht,
        setStates,
        categorie,
        setKlachten,
        setExtra
      );
    } else {
      ok = await opslaanOpmerkingKlachten(
        klacht,
        selectKlacht,
        setStates,
        categorie,
        admin,
        setOpen
      );
    }

    if (ok && meta.id < 17) {
      setSelectKlacht((prev) =>
        Math.min(prev + 1, benamingKlachten.length - 1)
      );
    }
    return ok;
  };

  const updateKlachten = (categoryKey, itemKey, newValue) => {
    setKlachten((prevState) => {
      const prevField = prevState[categoryKey]?.[itemKey];
      const nextVal =
        prevField &&
        typeof prevField === "object" &&
        prevField !== null &&
        "value" in prevField
          ? { ...prevField, value: newValue }
          : newValue;
      return {
        ...prevState,
        [categoryKey]: {
          ...prevState[categoryKey],
          [itemKey]: nextVal,
        },
      };
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (isSaving) return;

    const meta = benamingKlachten[selectKlacht];
    if (!meta) return;

    try {
      setIsSaving(true);
      if (admin) {
        if (Opmerking === opAdminOpmerking) {
          if (meta.title === "Man") {
            setOpen(false);
          } else {
            setSelectKlacht((prev) =>
              Math.min(prev + 1, benamingKlachten.length - 1)
            );
          }
        } else {
          await Opslaan();
        }
      } else {
        await Opslaan();
      }
    } finally {
      setIsSaving(false);
    }
  };

  const handlePrevious = (e) => {
    e.preventDefault();
    if (isSaving) return;

    if (slideIndex > 0 && selectKlacht === 0) {
      sliderRef.current?.slickGoTo(0);
      return;
    }
    if (selectKlacht > 0) {
      setSelectKlacht((prev) => Math.max(0, prev - 1));
    }
  };

  return (
    <div ref={topRef} className="mx-auto mt-4 w-full max-w-6xl px-3 pb-8 text-wa-text sm:mt-6 sm:px-4 lg:px-6">
      {extra == 1 ? (
        <Bedankt handleClose={() => setOpen(false)} versturen={verSturen} />
      ) : (
        <Slider
          ref={(slider) => {
            sliderRef.current = slider;
          }}
          {...settings}
        >
          <div>
            <div className="flex justify-center">
              <div className="w-full max-w-3xl rounded-2xl border border-wa-border bg-wa-panel2/35 p-5 shadow-sm ring-1 ring-black/[0.03] dark:bg-wa-panel/30 dark:ring-white/[0.05] sm:p-8">
                <h2 className="text-center text-xl font-bold tracking-tight text-wa-text sm:text-left sm:text-2xl">
                  Klachtenregister formulier &ldquo;Van kop tot teen&rdquo;
                </h2>
                <p className="mt-3 text-center text-sm leading-relaxed text-wa-muted sm:text-left">
                  Met meer dan 1 miljard biochemische reacties per seconde is ons lichaam een
                  van de meest complexe systemen. Deze vragenlijst helpt ons jouw lichaam
                  beter te begrijpen.
                </p>
                <p className="mt-3 text-center text-sm leading-relaxed text-wa-muted sm:text-left">
                  Noteer bij elke vraag op een schaal van{" "}
                  <span className="font-semibold text-wa-text">0 tot 3</span> hoe vaak je last
                  hebt en/of hoe belastend je de klacht ervaart.
                </p>
                <ul
                  role="list"
                  className="mt-8 grid grid-cols-1 gap-3 border-y border-wa-border/70 py-6 sm:grid-cols-2 sm:gap-4"
                >
                  {radiobutton1?.map((option) => (
                    <li key={option.id}>
                      <div className="flex items-center gap-3 rounded-xl border border-wa-border/80 bg-wa-panel/50 p-3 sm:p-4">
                        <div
                          className={classNames(
                            "flex h-12 w-12 shrink-0 items-center justify-center rounded-lg text-base font-bold",
                            "bg-wa-panel2 text-wa-accent ring-1 ring-inset ring-wa-border/70 dark:bg-wa-panel"
                          )}
                        >
                          {option.id}
                        </div>
                        <p className="min-w-0 flex-1 text-sm font-medium leading-snug text-wa-text">
                          {option?.title}
                        </p>
                      </div>
                    </li>
                  ))}
                </ul>
                <div className="mt-6 flex justify-center sm:justify-start">
                  <button
                    type="button"
                    onClick={() => {
                      sliderRef.current?.slickGoTo(1);
                      setSlideIndex(1);
                    }}
                    className="inline-flex items-center gap-2 rounded-xl bg-wa-accent px-5 py-2.5 text-sm font-semibold text-wa-onaccent shadow-md transition hover:bg-wa-accentdeep focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-wa-accent"
                  >
                    Beginnen met het invullen
                    <span aria-hidden="true">→</span>
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div className="px-1 sm:px-0">
            <div className="mb-4 flex flex-col gap-2 sm:flex-row sm:items-center sm:justify-between">
              <h2 className="text-xl font-bold tracking-tight text-wa-text sm:text-2xl">
                {benamingKlachten[selectKlacht]?.title}
              </h2>
              <p className="inline-flex items-center gap-1.5 rounded-lg border border-amber-500/35 bg-amber-500/10 px-2.5 py-1 text-xs font-medium text-amber-800 dark:text-amber-200">
                <ArrowDownIcon className="h-3.5 w-3.5 shrink-0" aria-hidden="true" />
                Scroll naar beneden voor alle vragen
              </p>
            </div>

            <div
              className="overflow-y-auto rounded-xl border border-wa-border/80 bg-wa-panel/30 px-2 py-3 ring-1 ring-black/[0.02] dark:bg-wa-panel2/20 sm:px-3"
              style={{ maxHeight: "min(52vh, 28rem)" }}
            >
              <div className="grid grid-cols-1 gap-3 lg:grid-cols-2 lg:gap-x-5 lg:gap-y-1">
                {klachten[benamingKlachten[selectKlacht]?.key] &&
                  extra == 0 &&
                  Object.entries(klachten[benamingKlachten[selectKlacht]?.key])
                    .filter(
                      ([key, value]) =>
                        key !== "opm_klant" &&
                        key !== "opm_admin" &&
                        key !== "id" &&
                        key != "admin_id" &&
                        key !== "klachtr_id"
                    )
                    .map(([key, value]) => (
                      <RPRadioButtonSmall
                        key={key}
                        legend={
                          KlachtenTitel[benamingKlachten[selectKlacht]?.key][key]
                        }
                        klachten={klachten}
                        keyHoofd={key}
                        categorie={benamingKlachten[selectKlacht]?.key}
                        updateKlachten={updateKlachten}
                        valueRadio={value}
                        Value={value}
                        admin={admin}
                      />
                    ))}
              </div>
            </div>

            <div className="mt-5">
              <label
                htmlFor="opm_klant"
                className="block text-sm font-semibold text-wa-text"
              >
                Wenst u nog andere dingen aan te vullen?
              </label>
              <textarea
                id="opm_klant"
                name="opm_klant"
                disabled={admin != null}
                value={klachten[benamingKlachten[selectKlacht]?.key]?.opm_klant|| ""}
                onChange={handleChange}
                rows="5"
                className="mt-2 block w-full resize-y rounded-xl border border-wa-border bg-wa-panel2/50 p-3 text-sm text-wa-text placeholder:text-wa-muted/70 ring-1 ring-inset ring-wa-border/50 focus:border-wa-accent focus:outline-none focus:ring-2 focus:ring-wa-accent/40 disabled:cursor-not-allowed disabled:opacity-60 dark:bg-wa-panel/40 sm:p-4"
              />
            </div>

            {admin != null && (
              <div className="mt-8">
                <label
                  htmlFor="opm_admin"
                  className="block text-sm font-semibold text-wa-text"
                >
                  Opmerking specialist
                </label>
                <textarea
                  id="opm_admin"
                  name="opm_admin"
                  value={klachten[benamingKlachten[selectKlacht]?.key]?.opm_admin || ""}
                  onChange={handleChange}
                  rows="5"
                  className="mt-2 block w-full resize-y rounded-xl border border-wa-border bg-wa-panel2/50 p-3 text-sm text-wa-text ring-1 ring-inset ring-wa-border/50 focus:border-wa-accent focus:outline-none focus:ring-2 focus:ring-wa-accent/40 dark:bg-wa-panel/40 sm:p-4"
                />
              </div>
            )}
            <div className="mt-6 flex flex-col gap-2 sm:flex-row sm:flex-wrap sm:items-center">
              {(slideIndex > 0 || selectKlacht > 0) && (
                <button
                  type="button"
                  onClick={handlePrevious}
                  disabled={isSaving}
                  className="inline-flex items-center justify-center gap-2 rounded-xl border border-wa-border bg-wa-panel2/60 px-4 py-3 text-sm font-semibold text-wa-text shadow-sm transition hover:bg-wa-hover disabled:cursor-not-allowed disabled:opacity-50 sm:mr-2"
                >
                  <ArrowLeftCircleIcon
                    aria-hidden="true"
                    className="h-5 w-5 text-wa-accent"
                  />
                  Vorige
                </button>
              )}
              <button
                type="button"
                onClick={handleSubmit}
                disabled={isSaving}
                className="inline-flex flex-1 items-center justify-center gap-2 rounded-xl bg-wa-accent px-4 py-3 text-sm font-semibold text-wa-onaccent shadow-md transition hover:bg-wa-accentdeep focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-wa-accent disabled:cursor-not-allowed disabled:opacity-60 sm:flex-none"
              >
                {isSaving ? "Bezig…" : "Volgende"}
                <ArrowRightCircleIcon
                  aria-hidden="true"
                  className="h-5 w-5"
                />
              </button>
            </div>
          </div>
        </Slider>
      )}
    </div>
  );
};

export default RpKlachtenRegisterForm;
